import { element } from 'protractor';
import { filter } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EncarteService } from '@services/encarte.service';
import { TipoPaginaService } from '@services/tipo-pagina.service';
import { SetorService } from '@services/setor.service';
import { LayoutService } from '@services/layout.service';
import { TipoPagina } from '@models/tipoPagina';
import { Layout } from '@models/layout';
import { Setor } from '@models/setor';
import { ToastrService } from 'ngx-toastr';
import { NzModalService } from 'ng-zorro-antd/modal';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-encarte-form',
  templateUrl: './encarte-form.component.html',
  styleUrls: ['./encarte-form.component.css']
})
export class EncarteFormComponent implements OnInit {

  encarteId = null;
  areaId = null;
  tipoPaginaId = null;
  setorId = null;
  layoutId = null;
  firtLoadVerify: boolean = true;
  slaId = null;
  tipoLayout = this.getTipoMidia();
  unit = "";

  tipoMidia = [
    { "id": 1, "descricao": "PDF" },
    { "id": 2, "descricao": "JPEG" },
    { "id": 3, "descricao": "HTML" }
  ];

  form = new UntypedFormGroup({
    encDescricao: new UntypedFormControl(null, [Validators.required, Validators.maxLength(64)]),
    slaId: new UntypedFormControl(null),


  });
  tipoPages: TipoPagina[];
  tipoPagesAll: TipoPagina[];
  setores: Array<object>;
  layouts: Array<Layout>;
  pages: Array<object>;
  areas: Array<object>;
  larguraQuadroEncarte: Array<string> = [];
  alturaQuadroEncarte: string = "144px"; // começa com 144, mas alterando "alturaFixaQuadroEncarte", ele ficará setado conforme esse valor
  alturaFixaQuadroEncarte: number = 144;
  imagensExampleLayoutArray: Array<Array<object>> = [];
  totalizadorPagina: Array<string> = [];
  alturaQuadroLayout: number = 144;
  imagemFundo: Array<any> = [];
  indexImageFundo: number = null;
  laytouTipos: Array<Object>;

  public userForm: UntypedFormGroup;
  public loading: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private encarteService: EncarteService,
    private tipoPaginaService: TipoPaginaService,
    private setorService: SetorService,
    private layoutService: LayoutService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private modal: NzModalService
  ) {

    this.userForm = this.formBuilder.group({
      encDescricao: "",
      encMargem: "10",
      encLimiteDuplicar: "3",
      encPercentualDuplicacao: "10",
      slaId: "",
      paginas: this.formBuilder.array([this.newPageGroup(0)]),
    });

    this.alturaQuadroEncarte = `${this.alturaFixaQuadroEncarte}px`

  }

  async getInitialInfo() {
    this.loading = true;
    return new Promise((resolve, reject) => {
      forkJoin([this.readSetor(), this.readTipoPagina(), this.readLayout()])
        .subscribe(([responseSetor, responseTipoPagina, responseLayout]) => {
          this.setores = responseSetor;
          this.tipoPagesAll = responseTipoPagina;
          this.layouts = responseLayout.filter((item) => item.layAltura)
            .map((item) => {
              return ({
                ...item,
                "layExemplo": item.layExemplo && item.layExemplo !== ""
                  ? item.layExemplo
                  : 'data:image/jpg;base64,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'
              })
            });
          this.loading = false;
          resolve(true);
        },
          error => {
            this.loading = false;
            this.toastr.error(error.message, 'Erro ao buscar informações iniciais!');
            reject(error);
          });
    });
  }

  async ngOnInit() {
    this.encarteId = this.route.snapshot.paramMap.get('id');

    await this.getInitialInfo();

    if (!!this.encarteId) {
      this.getEncarte(this.encarteId);
    }

    this.firtLoadVerify = false;
  }

  getTipoMidia() {

    return [
      { "id": 1, "descricao": "PDF" },
      { "id": 2, "descricao": "JPEG" },
      { "id": 3, "descricao": "HTML" }
    ];
  }

  get pagesArray(): UntypedFormArray {

    return <UntypedFormArray>this.userForm.get('paginas');

  }

  private newPageGroup(indexPagina?): UntypedFormGroup {

    return this.formBuilder.group({
      tpgId: "",

      pagOrdem: indexPagina || indexPagina === 0 ? (indexPagina + 1) : null,
      pagFundo: null,
      areas: this.formBuilder.array([this.newAreaGroup(0)])
    });

  }

  private newAreaGroup(indexArea?): UntypedFormGroup {

    return this.formBuilder.group({
      layId: "",
      slaId: "",
      areAprovacao: true,
      areOrdem: indexArea || indexArea === 0 ? (indexArea + 1) : null,
      setoresString: null
    });

  }

  setndexImagemFundo(i) {

    this.indexImageFundo = i;

  }

  carregarImagemFundo(files: any) {


    this.loading = true;

    const uploaded = files[0];
    if (!uploaded) {
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.pagesArray.at(this.indexImageFundo).patchValue({
        ...this.pagesArray.controls[this.indexImageFundo],
        pagFundo: reader.result,
      });
    };

    reader.readAsDataURL(uploaded);
    this.loading = false;

  }

  alteraImagemExemploLayout(pageIndex, position): void {

    if (this.imagensExampleLayoutArray[pageIndex] == null) this.imagensExampleLayoutArray[pageIndex] = []

    const imageAux = this.imagensExampleLayoutArray[pageIndex];

    this.imagensExampleLayoutArray[pageIndex] = this.imagensExampleLayoutArray[position];
    this.imagensExampleLayoutArray[position] = imageAux;

  }

  invertePaginaOrdemEmCima(pageIndex) {

    const pagePrevOrdem = this.pagesArray.controls[pageIndex - 1];
    const larguraQuadroEncartePrev = this.larguraQuadroEncarte[pageIndex - 1]

    this.pagesArray.controls[pageIndex - 1] = this.pagesArray.controls[pageIndex];
    this.pagesArray.controls[pageIndex - 1].value.pagOrdem = pageIndex;
    this.larguraQuadroEncarte[pageIndex - 1] = this.larguraQuadroEncarte[pageIndex];

    this.alteraImagemExemploLayout(pageIndex, pageIndex - 1);

    this.pagesArray.controls[pageIndex] = pagePrevOrdem;
    this.pagesArray.controls[pageIndex].value.pagOrdem = pageIndex + 1;
    this.larguraQuadroEncarte[pageIndex] = larguraQuadroEncartePrev;
  }

  invertePaginaOrdemEmBaixo(pageIndex) {

    const pageNextOrdem = this.pagesArray.controls[pageIndex + 1];
    const larguraQuadroEncartePrev = this.larguraQuadroEncarte[pageIndex + 1]

    this.pagesArray.controls[pageIndex + 1] = this.pagesArray.controls[pageIndex];
    this.pagesArray.controls[pageIndex + 1].value.pagOrdem = pageIndex + 2;
    this.larguraQuadroEncarte[pageIndex + 1] = this.larguraQuadroEncarte[pageIndex];

    this.alteraImagemExemploLayout(pageIndex, pageIndex + 1);

    this.pagesArray.controls[pageIndex] = pageNextOrdem;
    this.pagesArray.controls[pageIndex].value.pagOrdem = pageIndex + 1;
    this.larguraQuadroEncarte[pageIndex] = larguraQuadroEncartePrev;

  }


  inverteAreaOrdemEmCima(area, pageIndex, areaIndex) {

    const areaPrevAreOrdem = this.pagesArray.controls[pageIndex].value.areas[areaIndex - 1];

    (<UntypedFormArray>(<UntypedFormGroup>this.pagesArray.controls[pageIndex]).controls.areas).at(areaIndex - 1).patchValue({
      ...area
    });

    (<UntypedFormArray>(<UntypedFormGroup>this.pagesArray.controls[pageIndex]).controls.areas).at(areaIndex).patchValue({
      ...areaPrevAreOrdem
    })

  }

  inverteAreaOrdemEmBaixo(area, pageIndex, areaIndex) {

    const areaNextAreOrdem = this.pagesArray.controls[pageIndex].value.areas[areaIndex + 1];

    (<UntypedFormArray>(<UntypedFormGroup>this.pagesArray.controls[pageIndex]).controls.areas).at(areaIndex).patchValue({
      ...areaNextAreOrdem
    });

    (<UntypedFormArray>(<UntypedFormGroup>this.pagesArray.controls[pageIndex]).controls.areas).at(areaIndex + 1).patchValue({
      ...area
    })

  }

  calcTotalizadorPagina (indexPagina): void {
    if (this.pagesArray.controls == null || indexPagina >= this.pagesArray.controls.length )
      return;
      
    this.totalizadorPagina[indexPagina] = "";
    var totalUtilizado = 0;
    var totalPagina = 0;
    let element = (<UntypedFormArray>(<UntypedFormGroup>this.pagesArray.controls[indexPagina]).controls.areas).controls;
    let elementPag = (<UntypedFormGroup>this.pagesArray.controls[indexPagina]).controls;
    for (var k = 0; k < element.length; k++) {
      for (var j = 0; j < this.layouts.length; j++) {
        if (this.layouts[j].id == element[k].value.layId) {
          totalUtilizado += this.layouts[j].layAltura;
          break;
        }
      }
    }

    for (var j = 0; j < this.tipoPages.length; j++) {
      if (this.tipoPages[j].id == elementPag.tpgId.value) {
        totalPagina = this.tipoPages[j].tpgAltura;
        break;
      }
    }


    this.totalizadorPagina[indexPagina] = totalUtilizado + "mm de " + totalPagina + "mm";
  }



  extraiImagemExemploLayout(idLayout, tipoPaginaId, indexPagina, indexSessao): void {
    this.calcTotalizadorPagina(indexPagina);

    const imagemExemploFiltrada = this.layouts && this.layouts.filter((item: any) => item.id === idLayout);

    if (this.imagensExampleLayoutArray[indexPagina] == null) this.imagensExampleLayoutArray[indexPagina] = []
    this.imagensExampleLayoutArray[indexPagina][indexSessao] = {

      base64: imagemExemploFiltrada && imagemExemploFiltrada[0] ? imagemExemploFiltrada[0]['layExemplo'] : "",
      layAlturaPx: this.calculaAlturaLayoutExemplo(imagemExemploFiltrada && imagemExemploFiltrada[0]
        ? imagemExemploFiltrada[0]['layAltura']
        : 100, tipoPaginaId)

    };
  }

  calculaAlturaLayoutExemplo(layAltura, tpgId): number {

    const dimensao = this.tipoPages && this.tipoPages.filter((item: any) => item.id === tpgId)
      .map((itemx) => {
        return ({
          tpgAltura: itemx.tpgAltura,
        })
      }
      )

    if ((layAltura >= (dimensao[0] && dimensao[0].tpgAltura))) return;

    const altura = dimensao[0] ? dimensao[0].tpgAltura : null;
    const dimensaoAlturaEmPx = altura ? ((this.alturaFixaQuadroEncarte * layAltura) / altura) : 100;

    return dimensaoAlturaEmPx

  }

  calculaDimensaoPaginaExemploPorId(id, indexPagina): void {

    const dimensao = this.tipoPages && this.tipoPages.filter((item: any) => item.id === id)
      .map((itemx) => {
        return ({
          tpgAltura: itemx.tpgAltura,
          tpgLargura: itemx.tpgLargura
        })
      }
      )

    const altura = dimensao && dimensao[0] ? dimensao[0].tpgAltura : 1;
    const largura = dimensao && dimensao[0] ? dimensao[0].tpgLargura : 1;
    const dimensaoLarguraEmPx = altura != 0 ? ((this.alturaFixaQuadroEncarte * largura) / altura) : 100

    this.larguraQuadroEncarte[indexPagina] = dimensaoLarguraEmPx.toString() + "px";

  }

  addPage(): void {

    this.pagesArray.push(this.newPageGroup(this.pagesArray.value.length));

  }

  deletePage(indexPagina): void {
    this.imagensExampleLayoutArray.splice(indexPagina, 1);
    this.larguraQuadroEncarte.splice(indexPagina, 1);
    this.pagesArray.removeAt(indexPagina);

  }

  addArea(indexPagina): void {

    //console.log({"antes":this.pagesArray.controls[index]});

    (<UntypedFormArray>
      (<UntypedFormGroup>this.pagesArray.controls[indexPagina]).controls.areas
    ).push(this.newAreaGroup(
      (<UntypedFormArray>
        (<UntypedFormGroup>this.pagesArray.controls[indexPagina]).controls.areas
      ).length
    ));
    this.calcTotalizadorPagina(indexPagina);
  }

  deleteArea(indexPagina, indexArea): void {

    if (this.imagensExampleLayoutArray[indexPagina]) this.imagensExampleLayoutArray[indexPagina].splice(indexArea, 1);

    (<UntypedFormArray>
      (<UntypedFormGroup>this.pagesArray.controls[indexPagina]).controls.areas
    ).removeAt(indexArea);
    this.calcTotalizadorPagina(indexPagina);
  }

  filterLayouts(layouts, tpgId): any[] {

    const tpgAltura = this.tipoPages && this.tipoPages.filter((item: any) => item.id === tpgId)
      .map((itemx) => {
        return ({
          tpgAltura: itemx.tpgAltura,
        })
      }
      )

    const altura = tpgAltura && tpgAltura[0] && tpgAltura[0].tpgAltura ? tpgAltura[0].tpgAltura : null;

    const lays =  layouts && layouts.filter((item) => item.layAltura <= altura && item.slaId == this.userForm.get('slaId').value);
    return lays;
  }


  filterTipoPagina(slaId:number) {
    this.tipoPages =  this.tipoPagesAll && this.tipoPagesAll.filter((item) => item.slaId == slaId);
  }


  readSetor() {
    return this.setorService.listAll();
  }

  readTipoPagina() {
    return this.tipoPaginaService.listAll();
  }

  readLayout() {
    return this.layoutService.listAll();
  }

  // Para marcar os setores selecionados
  compareFn(o1: any, o2: any): boolean {
    if (o1 && o2 && o1.id == o2.id)
      return true;
    return false;
  }

  readEncarteJsonToForm(encarte): void {

    this.encarteId = encarte.id
    this.userForm.get("encDescricao").setValue(encarte.encDescricao)
    this.userForm.get("encMargem").setValue(encarte.encMargem)
    this.userForm.get("encLimiteDuplicar").setValue(encarte.encLimiteDuplicar)
    this.userForm.get("encPercentualDuplicacao").setValue(encarte.encPercentualDuplicacao)
    this.userForm.get("slaId").setValue(encarte.slaId)

    this.pagesArray.removeAt(0);

    encarte.paginas && encarte.paginas.sort((itemSortA, itemSortB) => itemSortA.pagOrdem - itemSortB.pagOrdem)
      .map((item, indexPagina) => {

        this.calculaDimensaoPaginaExemploPorId(item.tpgId, indexPagina)
        this.pagesArray.push(
          <UntypedFormGroup>this.formBuilder.group({
            id: item.id,
            tpgId: item.tpgId,
            pagOrdem: item.pagOrdem,
            pagFundo: item.pagFundo,
            areas: this.formBuilder.array(
              item.areas && item.areas.sort((itemSortAreaA, itemSortAreaB) => itemSortAreaA.areOrdem - itemSortAreaB.areOrdem).map((area, indexArea) => {

                this.extraiImagemExemploLayout(area.layId, item.tpgId, indexPagina, indexArea);

                var setoresStringSelected = new Array();
                area.areaSetores.forEach(areaSetor => {
                  setoresStringSelected.push({ "id": areaSetor.depId });
                });

                var fg = this.formBuilder.group({
                  id: area.id,
                  layId: area.layId,
                  areAprovacao: area.areAprovacao == 'S' ? true : false,
                  areOrdem: area.areOrdem,
                  setoresString: [setoresStringSelected],
                  //setores:this.setores
                  //setoresStringSelected: setoresStringSelected
                });

                return <UntypedFormGroup>fg;

              })

            )
          })
        )
      });

      for (let idx = 0; idx < this.pagesArray.length; idx++) {
        this.calcTotalizadorPagina(idx);
      }

  }

  getEncarte(id): void {

    this.loading = true;
    this.encarteService.read(id)
      .subscribe(
        encarte => {
          this.loading = false;
          this.readEncarteJsonToForm(encarte)
          this.verCurrentTipoLayout(encarte.slaId)
        },
        error => {
          this.loading = false;
          console.log(error);
          this.toastr.error(error.message, 'Erro ao Recuperar!');
        });

  }

  salvarEncarte(): void {

    this.loading = true;

    if (!!this.encarteId) {
      const body = {
        id: this.encarteId,
        ...this.userForm.value,
      }

      var ordemPagina = 1;
      body.paginas.forEach(pagina => {
        //pagina.pagOrdem = ordemPagina;
        ordemPagina++;

        var ordemArea = 1;
        pagina.areas.forEach(area => {
          area.areOrdem = ordemArea;
          ordemArea++;

          var setores = new Array();
          var ordem = 1;
          if (area.setoresString != null) {
            area.setoresString.forEach(setorString => {
              setores.push({ depId: setorString.id, aetOrdem: ordem });
              ordem++;
            });
          }
          area.setoresString = null;
          area.areaSetores = setores;
        });
      });



      this.encarteService.update(body)
        .subscribe(
          response => {
            this.loading = false;
            this.router.navigateByUrl('/encarte/list');
            this.toastr.success('Encarte Salvo!', 'Gravado com Sucesso!');
          },
          error => {
            this.loading = false;
            console.log(error);
            this.toastr.error(error.message, 'Erro ao Salvar!');
          });

    } else {

      const body = {
        ...this.userForm.value,
      }

      var ordemPagina = 1;
      body.paginas.forEach(pagina => {
        //pagina.pagOrdem = ordemPagina;
        ordemPagina++;

        var ordemArea = 1;
        pagina.areas.forEach(area => {
          var setores = new Array();
          var ordem = 1;
          if (area.setoresString != null) {
            area.setoresString.forEach(setorString => {
              setores.push({ depId: setorString.id, aetOrdem: ordem });
              ordem++;
            });
          }
          area.setoresString = null;
          area.areaSetores = setores;
        });
      });


      this.encarteService.create(body)
        .subscribe(
          response => {
            this.loading = false;
            this.router.navigateByUrl('/encarte/list');
            this.toastr.success('Encarte Criado!', 'Gravado com Sucesso!');
          },
          error => {
            this.loading = false;
            console.log(error);
            this.toastr.error(error.message, 'Erro ao Salvar!');
          });

    }

  }

  cancelar(): void {

    this.router.navigateByUrl('/encarte/list');

  }

  oldSlaId = 0;
  verCurrentTipoLayout(id: number): void {
    if (id == 1)
      this.unit = "mm";
    else
      this.unit = "px";

    this.oldSlaId = id;
    this.filterTipoPagina(id);
    this.getListTypeLayout(id);
  }

  getListTypeLayout(id: number) {
    this.loading = true;
    this.layoutService.listTipoLayout(id)
      .subscribe(data => {
        this.loading = false;
        this.layouts = data;
      },
        error => {
          this.loading = false;
          console.log(error);
          this.toastr.error(error.message, 'Erro ao buscar Tipos de Layout!');
        });
  }

  generateQtdDescr(items){


     const description = items?.layDescricao;
     const qtdDisponiveis = items?.qtdDisponiveis?.join(", ");
     return `${description}  (Qtd Disponiveis: ${qtdDisponiveis})`;

  }



}
